import React, { Fragment } from "react";
import avatar from "./1539813211021.png"
function Aboutauthor() {
  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-md-3 col-sm-3 col-xs-12">
          <div className="avtar">
            <img
              src= {avatar}
              style={{ borderRadius: "50%", width: 200 }}
              alt="avtar"
            />
          </div>
        </div>

        <div className="col-md-9 col-sm-9 col-xs-12">
          <h2>Chengcheng Ding</h2>
          <p> Master of InfoSec at Carnegie Melon University </p>
        </div>
      </div>

      <br />
      <hr></hr>
      <h4>
        Hi there, I'm Chengcheng Ding
        <span>
        <g-emoji
          className="g-emoji"
          alias="wave"
          fallback-src="https://github.githubassets.com/images/icons/emoji/unicode/1f44b.png"
        >
          👋
        </g-emoji>
        </span>
      </h4>
      <br />
      <h4>
        I'm a Developer, Student, and Passionate Gamer!
      </h4>
      <br />
      <hr></hr>
      <h3>
        Languages and Tools:
      </h3>
      <p>
        <a href="https://code.visualstudio.com/" rel="nofollow">
          <code>
            <img
              alt="visual studio code"
              width="26px"
              src="https://img.icons8.com/fluent/240/000000/visual-studio-code-2019.png"
            />
          </code>
        </a>
        <a href="https://www.jetbrains.com/idea/" rel="nofollow">
          <code>
            <img
              alt="intellij idea"
              width="26px"
              src="https://img.icons8.com/color/240/000000/intellij-idea.png"
            />
          </code>
        </a>
        <a href="https://www.jetbrains.com/pycharm/" rel="nofollow">
          <code>
            <img
              alt="pycharm"
              width="26px"
              src="https://img.icons8.com/color/240/000000/pycharm.png"
            />
          </code>
        </a>
        <a
          href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
          rel="nofollow"
        >
          <code>
            <img
              alt="javascript"
              width="26px"
              src="https://img.icons8.com/color/240/000000/javascript.png"
            />
          </code>
        </a>
        <a href="https://reactjs.org/" rel="nofollow">
          <code>
            <img
              alt="react"
              width="26px"
              src="https://img.icons8.com/color/240/000000/react-native.png"
            />
          </code>
        </a>
        <a href="https://docs.oracle.com/en/java/" rel="nofollow">
          <code>
            <img
              alt="java"
              width="26px"
              src="https://img.icons8.com/color/240/000000/java-coffee-cup-logo.png"
            />
          </code>
        </a>
        <a href="https://www.python.org/" rel="nofollow">
          <code>
            <img
              alt="python"
              width="26px"
              src="https://img.icons8.com/color/240/000000/python.png"
            />
          </code>
        </a>
        <a
          href="https://developer.mozilla.org/en-US/docs/Web/HTML"
          rel="nofollow"
        >
          <code>
            <img
              alt="html5"
              width="26px"
              src="https://img.icons8.com/color/240/000000/html-5.png"
            />
          </code>
        </a>
        <a href="https://nodejs.org/en/" rel="nofollow">
          <code>
            <img
              alt="Node.js"
              width="26px"
              src="https://img.icons8.com/color/240/000000/nodejs.png"
            />
          </code>
        </a>
        <a href="https://www.mongodb.com/" rel="nofollow">
          <code>
            <img
              alt="MongoDB"
              width="26px"
              src="https://img.icons8.com/color/2x/mongodb.png"
            />
          </code>
        </a>
        <a href="https://www.latex-project.org/" rel="nofollow">
          <code>
            <img
              alt="latex"
              width="26px"
              src="https://img.icons8.com/fluency/2x/texshop.png"
            />
          </code>
        </a>
        <a href="https://www.markdownguide.org/" rel="nofollow">
          <code>
            <img
              alt="markdown"
              width="26px"
              src="https://img.icons8.com/ios-filled/100/000000/markdown.png"
            />
          </code>
        </a>
        <a href="https://git-scm.com/" rel="nofollow">
          <code>
            <img
              alt="Git"
              width="26px"
              src="https://img.icons8.com/color/240/000000/git.png"
            />
          </code>
        </a>
        <a href="https://github.com/">
          <code>
            <img
              alt="github"
              width="26px"
              src="https://img.icons8.com/ios-glyphs/240/000000/github.png"
            />
          </code>
        </a>
        <a
          href="https://docs.microsoft.com/en-us/windows/terminal/"
          rel="nofollow"
        >
          <code>
            <img
              alt="terminal"
              width="26px"
              src="https://img.icons8.com/external-flaticons-lineal-flat-icons/2x/external-terminal-computer-programming-flaticons-lineal-flat-icons.png"
            />
          </code>
        </a>

        <a href="https://www.microsoft.com/en-us/windows" rel="nofollow">
          <code>
            <img
              alt="windows"
              width="26px"
              src="https://img.icons8.com/color/240/000000/windows-10.png"
            />
          </code>
        </a>
        <a href="https://ubuntu.com/" rel="nofollow">
          <code>
            <img
              alt="ubuntu"
              width="26px"
              src="https://img.icons8.com/color/96/000000/ubuntu--v1.png"
            />
          </code>
        </a>
        <a href="https://www.kernel.org/" rel="nofollow">
          <code>
            <img
              alt="linux"
              width="26px"
              src="https://img.icons8.com/color/96/000000/linux.png"
            />
          </code>
        </a>
        <a href="https://www.tensorflow.org/" rel="nofollow">
          <code>
            <img
              alt="tensorflow"
              width="26px"
              src="https://img.icons8.com/color/344/tensorflow.png"
            />
          </code>
        </a>
        <a href="https://www.tensorflow.org/" rel="nofollow">
          <code>
            <img
              alt="huggingface"
              width="26px"
              src="https://huggingface.co/front/assets/huggingface_logo-noborder.svg"
            />
          </code>
        </a>
      </p>
      <hr></hr>
      <h4>
        My most updated resume:
      </h4>
      <Fragment>
        <iframe title="Resume" src="https://drive.google.com/file/d/1jB_2bKQygXwOZ3lSj83A-LpdLPRZpzbX/preview" width="90%" height="960" align="center" allow="autoplay"></iframe>
      </Fragment>

    </div>
  );
}

export default Aboutauthor;
